import { render, staticRenderFns } from "./TkbSwiftsRemoveModal.vue?vue&type=template&id=22dae8d9"
import script from "./TkbSwiftsRemoveModal.vue?vue&type=script&lang=js"
export * from "./TkbSwiftsRemoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports